import type { BlocksContent } from '@strapi/blocks-react-renderer';
import { RichText } from '@/lib/render/RichText';

interface HeroCardBodyProps {
  nodes: BlocksContent | null;
}

/**
 * One rich-text field serves every card body. `.benefits-checkmarks` is scoped
 * to `ul > li` (see `app/globals.css`), so the same wrapper gives checkmarks to
 * list items and leaves paragraphs untouched — which is what lets one field
 * carry both a benefits list and a plain address block.
 */
export function HeroCardBody({ nodes }: HeroCardBodyProps) {
  if (!nodes) {
    return null;
  }
  return (
    // No text colour of its own: the body inherits the panel's foreground,
    // matching the legacy site where only the checkmark glyph is primary
    // (`.list-icon-check-blue li:before { color: #0050a0 }`) and the text stays
    // dark. `.benefits-checkmarks`'s glyph hardcodes `var(--color-primary)`, so
    // it needs no `text-primary` here to get it.
    //
    // Lists stay left-aligned and full width even inside a centered card, so
    // every checkmark sits in one column at the card's left edge. Deliberately
    // not a centred flex column: that shrink-wrapped the list to its content
    // and floated it mid-panel, which reads as centred text once the items are
    // short.
    <div className="benefits-checkmarks w-full text-sm md:text-base [&_li]:text-left [&_ol]:text-left [&_p]:m-0 [&_ul]:text-left">
      <RichText nodes={nodes} />
    </div>
  );
}
